module.exports = __webpack_public_path__ + "img/lj.e48e2bc5.png";